import { createContext, useContext, useMemo, useReducer } from 'react';
import { generateTicketNumber } from '../utils/ticketNumber';

const emptyShoe = { brand: '', model: '', size: '', gum: '', service: '' };
const emptyClient = { familyName: '', givenName: '', email: '', phone: '' };

const initialState = {
  shoes: [],
  currentShoe: emptyShoe,
  client: emptyClient,
  tickets: [],
};

function reducer(state, action) {
  switch (action.type) {
    case 'SET_BRAND':
      return { ...state, currentShoe: { ...state.currentShoe, brand: action.brand, model: '' } };
    case 'SET_MODEL':
      return { ...state, currentShoe: { ...state.currentShoe, model: action.model } };
    case 'SET_SIZE':
      return { ...state, currentShoe: { ...state.currentShoe, size: action.size } };
    case 'SET_GUM':
      return { ...state, currentShoe: { ...state.currentShoe, gum: action.gum } };
    case 'SET_SERVICE':
      return { ...state, currentShoe: { ...state.currentShoe, service: action.service } };
    case 'CONFIRM_CURRENT_SHOE':
      return {
        ...state,
        shoes: [...state.shoes, state.currentShoe],
        currentShoe: emptyShoe,
      };
    case 'REMOVE_SHOE':
      return {
        ...state,
        shoes: state.shoes.filter((_, index) => index !== action.index),
      };
    case 'SET_CLIENT':
      return { ...state, client: action.client };
    case 'CONFIRM_ORDER':
      return {
        ...state,
        tickets: state.shoes.map((shoe) => ({
          shoe,
          number: generateTicketNumber(),
        })),
      };
    case 'RESET_ORDER':
      return initialState;
    default:
      return state;
  }
}

const TunnelStateContext = createContext(null);
const TunnelDispatchContext = createContext(null);

export function TunnelProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const stateValue = useMemo(() => state, [state]);

  return (
    <TunnelStateContext.Provider value={stateValue}>
      <TunnelDispatchContext.Provider value={dispatch}>
        {children}
      </TunnelDispatchContext.Provider>
    </TunnelStateContext.Provider>
  );
}

export function useTunnelState() {
  const context = useContext(TunnelStateContext);
  if (!context) {
    throw new Error('useTunnelState must be used within a TunnelProvider');
  }
  return context;
}

export function useTunnelDispatch() {
  const context = useContext(TunnelDispatchContext);
  if (!context) {
    throw new Error('useTunnelDispatch must be used within a TunnelProvider');
  }
  return context;
}
